import { render, staticRenderFns } from "./PageWineUpdateForm.vue?vue&type=template&id=11f3e9d0"
import script from "./PageWineUpdateForm.vue?vue&type=script&lang=ts"
export * from "./PageWineUpdateForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports